import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { selectStrategicInitiativesSelectedRtm } from '../selectors'
import { rtmSelected } from '../strategicInitiativesSlice'
import { TStrategicInitiativesRtm } from '../types'

export const useStrategicInitiativesRtm = () => {
  const dispatch = useAppDispatch()
  const rtm = useSelector(selectStrategicInitiativesSelectedRtm)

  const setRtm = useCallback(
    (value: TStrategicInitiativesRtm) => {
      dispatch(rtmSelected(value))
    },
    [dispatch]
  )

  return { rtm, setRtm }
}
